export function deepClone(obj, options, objects) {
    if (obj == null || typeof obj !== 'object') {
        return obj;
    }
    if (!objects) {
        objects = new Map();
    }
    let clone = objects.get(obj);
    if (clone) {
        if (options === null || options === void 0 ? void 0 : options.throwOnCircular) {
            throw new Error('Circular reference detected');
        }
        return clone;
    }
    if (Array.isArray(obj)) {
        clone = [];
        objects.set(obj, clone);
        for (let i = 0, len = obj.length; i < len; i++) {
            clone[i] = deepClone(obj[i], options, objects);
        }
        return clone;
    }
    // clone object
    clone = {};
    objects.set(obj, clone);
    for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            clone[key] = deepClone(obj[key], options, objects);
        }
    }
    return clone;
}
